export const verifyLogin = () => {
  const dataUserLS = localStorage.getItem('userDataLogin')
  if (dataUserLS != null) {
    return true;
  } else {
    return false;
  }
};
